/**
 *
 * Asynchronously loads the component for Pricing
 *
 */

import { lazyLoad } from 'src/utils/loadable';

export const Callback = lazyLoad(
  () => import('./index'),
  (module: { Callback: any }): any =>
    module.Callback,
);
